/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type Patient from "parog-web/models/patient";

import { service } from "@ember/service";
import type CrohnSurveyFilledJournalEvent from "parog-web/models/crohn-survey-filled-journal-event";
import type RchSurveyFilledJournalEvent from "parog-web/models/rch-survey-filled-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

import styles from "./index.module.css";

interface Signature {
  Args: {
    patient: Patient;
    journalEvents:
      | RchSurveyFilledJournalEvent[]
      | CrohnSurveyFilledJournalEvent[];
    title: string;
    feature: string;
    component: string;
    modelName: string;
  };
}

export default class extends Component<Signature> {
  styles = styles;

  @service declare session: SemeiaSessionService;

  get title() {
    if (this.session.medic) {
      return this.args.title;
    }
    return "Historique des symptômes";
  }
}
